import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import * as colors from '../../../common/styles/colors';

import { ButtonPrimary } from '../../../common/components';

type DataRequestedModalProps = {
  show: boolean;
  onHide: Function;
  dataType: string;
};

const defaultProps = {
  show: false,
  dataType: null,
};

export const DataRequestedWrapper = styled.div`
  .modal-title {
    color: ${colors.hydroBlue};
  }
`;

export const DataRequestedModal = (props: DataRequestedModalProps) => {
  const handleClose = (event: any) => {
    event.preventDefault();
    props.onHide();
  };

  return (
    <Modal animation={false} className={'custom-modal'} show={props.show} backdrop='static' centered>
      <DataRequestedWrapper>
        <Modal.Title>
          <div className='text-center'>{props.dataType} data requested</div>
        </Modal.Title>

        <Modal.Body>
          <div className='text-center'>
            <div className='pt-3'>
              <p>Thank you for your request.</p>
              <p>
                Depending on the size of your request, it could take us up <br />
                to 24 hours to deliver the data.
              </p>
              <p>
                We'll let you know via email when the data's available - <br />
                you'll then be able to access it via 'Messages' once you've logged in.
              </p>
            </div>
          </div>
        </Modal.Body>

        <div className='d-flex justify-content-end'>
          <ButtonPrimary className='m-0' title='OK' onClick={handleClose} />
        </div>
      </DataRequestedWrapper>
    </Modal>
  );
};

DataRequestedModal.defaultProps = defaultProps;
